export default __webpack_public_path__ + "static/media/30.b2c50f89.svg";